var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumaFullWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 32,
    viewBox: "0 0 110 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.2676,
    y: 14.5312,
    width: 11.2329,
    height: 3.7961,
    fill: "#B246FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5504 4.36143C13.8712 2.70849 7.67824 5.39263 5.09887 10.9144C2.5195 16.4362 4.43795 22.9028 9.35359 26.1903L15.2234 13.6244L19.5504 4.36143Z",
    fill: "url(#paint0_linear_3796_15720)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7582 5.81045C27.6739 9.09796 29.5923 15.5645 27.0129 21.0863C24.4336 26.6081 18.2406 29.2923 12.5614 27.6393L18.4312 15.0735L22.7582 5.81045Z",
    fill: "url(#paint1_linear_3796_15720)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7978 25.4784C60.369 25.4784 59.5533 25.226 58.4319 24.7212C57.5247 24.0856 56.7982 23.3482 56.2877 22.5849C55.6727 21.6655 55.3652 20.153 55.3652 19.4481V13.0373L59.8972 12.2283V19.367C59.8972 19.8252 60.06 20.3839 60.3855 20.7265C60.7292 21.051 61.3739 21.2599 61.8803 21.2599C62.3686 21.2599 63.0417 21.051 63.3492 20.7265C63.6748 20.3839 63.8375 19.9072 63.8375 19.367V12.4761L68.3435 11.6445V19.4481C68.3435 20.3987 68.036 21.6926 67.4211 22.612C66.8242 23.5134 66.1971 24.2164 65.1119 24.7212C64.0267 25.226 63.2086 25.4784 61.7978 25.4784Z",
    fill: "#FBFBFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0852 11.3862C78.5141 11.3862 79.1655 11.6386 80.2868 12.1434C81.194 12.779 81.9206 13.5164 82.4311 14.2797C83.046 15.1991 83.3535 16.7116 83.3535 17.4165L83.3535 25.1504L78.8215 25.1504L78.8215 17.4976C78.8215 16.9027 78.6588 16.434 78.3332 16.0914C77.9896 15.7669 77.5645 15.6047 77.0581 15.6047C76.5697 15.6047 76.1718 15.7669 75.8644 16.0914C75.5388 16.434 75.376 16.9027 75.376 17.4976L75.376 25.1504L70.8701 25.1504L70.8701 17.4165C70.8701 16.4658 71.1776 15.172 71.7925 14.2526C72.3894 13.3512 73.0164 12.6481 74.1017 12.1434C75.1869 11.6386 75.6744 11.3862 77.0852 11.3862Z",
    fill: "#FBFBFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3313 11.3862C86.7602 11.3862 87.4116 11.6386 88.5329 12.1434C89.4401 12.779 90.1667 13.5164 90.6772 14.2797C91.2921 15.1991 91.5996 16.7116 91.5996 17.4165L91.5996 25.1504L87.0676 25.1504L87.0676 17.4976C87.0676 16.9027 86.9049 16.434 86.5793 16.0914C86.2357 15.7669 85.8106 15.6047 85.3042 15.6047C84.8158 15.6047 84.4179 15.7669 84.1105 16.0914C83.7849 16.434 83.6221 16.9027 83.6221 17.4976L83.6221 25.1504L79.1162 25.1504L79.1162 17.4165C79.1162 16.4658 79.4237 15.172 80.0386 14.2526C80.6355 13.3512 81.2625 12.6481 82.3477 12.1434C83.433 11.6386 83.9205 11.3862 85.3313 11.3862Z",
    fill: "#FBFBFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.156 23.6257C103.958 24.5876 102.433 25.1636 100.773 25.1636C96.9191 25.1636 93.7949 22.0599 93.7949 18.2312C93.7949 14.4026 96.9191 11.2988 100.773 11.2988C102.45 11.2988 103.99 11.8868 105.193 12.8667L109.115 12.1405V25.1635H105.156V23.6257ZM104.02 18.2812C104.02 20.0459 102.581 21.4765 100.804 21.4765C99.0279 21.4765 97.5879 20.0459 97.5879 18.2812C97.5879 16.5165 99.0279 15.0859 100.804 15.0859C102.581 15.0859 104.02 16.5165 104.02 18.2812Z",
    fill: "#FBFBFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.9023,
    y: 6.63477,
    width: 4.94816,
    height: 18.5161,
    fill: "#FBFBFC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4473,
    y: 6.63477,
    width: 4.94816,
    height: 18.5161,
    fill: "#FBFBFC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10.1536,
    height: 3.60562,
    transform: "matrix(0.985002 -0.172546 0.174757 0.984612 38.6934 15.3652)",
    fill: "#FBFBFC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3796_15720",
    x1: 18.5676,
    y1: 6.46542,
    x2: -11.3793,
    y2: 2.80595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3796_15720",
    x1: 21.7754,
    y1: 7.91443,
    x2: 43.7945,
    y2: 28.5214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B246FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6A8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumaFullWhite);
export default __webpack_public_path__ + "static/media/huma-full-white.bf0afd2d1c2f339c46f107b89acaf2ae.svg";
export { ForwardRef as ReactComponent };